import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

import EmpNavbar from "../Empowering/emp_components/EmpNavbar";
import ShortReelBanner from "./ShortReelsComponents/ShortReelBanner";
import ShortReelVideo from "./ShortReelsComponents/ShortReelVideo";
import Footer from "../Empowering/emp_components/Footer";
import { apiRequest, EPISODE_URL, EPISODE_LIST_URL } from "../utils/Helper";
import { useLocation } from "react-router-dom";
import ReelSlider from "../Empowering/emp_components/ReelSlider";
import SharePopup from "../common/Sharepopup";
import data from "../common/ShareText.json";

const ShortReels = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialEpisodeId = queryParams.get("episode_id");
  const [episodeId, setEpisodeId] = useState(initialEpisodeId);
  const [episodeData, setEpisodeData] = useState();
  const [episodeListData, setEpisodeListData] = useState();
  const [reeldata, setReeldata] = useState();

  const [showPopup, setShowPopup] = useState(false);
  const [popUpdata, setPopUpdata] = useState();

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const [link, setLink] = useState("");
  const [quote, setQuote] = useState("");
  const [sequence, setEpisodesequence] = useState("");

  const [twittermessage, setTwittermessage] = useState("");
  const [shareType, setShareType] = useState("");
  const [Type, setType] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndexForSlide, setActiveIndexForSlide] = useState(0);

  const handleShareData = (link, quote, twitterMessage, shareType) => {
    setLink(link);
    setQuote(quote);
    setTwittermessage(twitterMessage);
    setShareType(shareType);
  };

  const handleBack = () => {
    setShowPopup(false);
    setShow(false);
  };

  const handleclick = (index, list, indexforslide, type) => {
    console.log(index);
    setShowPopup(true);
    handleShow();
    setActiveIndex(index);
    setActiveIndexForSlide(indexforslide);
    setPopUpdata(list);
    setType(type);
  };

  useEffect(() => {
    if (episodeId) {
      const fetchEpisodeData = async () => {
        setEpisodeData();
        const url = `${EPISODE_URL}&episode_id=${episodeId}`;
        try {
          const response = await apiRequest(url);
          if (response && response.data.length > 0) {
            setEpisodeData(response?.data[0]);
            setReeldata(response?.data[0]?.parikshadata?.shorts);
            setEpisodesequence(response?.data[0].sequence);
          }
        } catch (error) {
          console.error("Failed to fetch episode data:", error);
        }
      };

      fetchEpisodeData();
    }
  }, [episodeId]);

  useEffect(() => {
    const fetchEpisodeListData = async () => {
      try {
        const response = await apiRequest(EPISODE_LIST_URL);
        if (response && response.data.length > 0) {
          setEpisodeListData(response?.data);
          if (!initialEpisodeId) {
            setEpisodeId(response?.data[0].id);
            setEpisodesequence(response?.data[0].sequence);
          }
        }
      } catch (error) {
        console.error("Failed to fetch episode list data:", error);
      }
    };

    fetchEpisodeListData();
  }, []);

  const handleEpisodeIdChange = (newId) => {
    setEpisodeId(newId);
  };

  return (
    <>
      <div className="emp_nav_shape">
        <EmpNavbar />
      </div>

      <Modal className="vshorts_pop" show={show} onHide={handleClose} centered>
        <Modal.Body>
          {showPopup && (
            <ReelSlider
              reel={reeldata}
              showpopup={showPopup}
              handleBack={handleBack}
              sharetext={data[episodeId]}
              activeIndex={activeIndex}
              activeIndexForSlide={activeIndexForSlide}
              Type={Type}
              handleShareData={handleShareData}
            />
          )}
        </Modal.Body>
      </Modal>

      {episodeData && episodeListData && episodeId && (
        <ShortReelBanner
          episodeData={episodeData}
          sequence={sequence}
          episodeListData={episodeListData}
          episodeId={episodeId}
          setEpisodeId={handleEpisodeIdChange}
          setEpisodesequence={setEpisodesequence}
          handleclick={handleclick}
          sharetext={data[episodeId]}
          handleShareData={handleShareData}
        />
      )}

      {episodeData && (
        <ShortReelVideo
          key={episodeId}
          episodeData={episodeData}
          handleclick={handleclick}
          isShortReel={true}
          sharetext={data[episodeId]}
          handleShareData={handleShareData}
        />
      )}
      <Footer />
      <SharePopup
        link={link}
        quote={quote}
        twittermessage={twittermessage}
        shareType={shareType}
      />
    </>
  );
};

export default ShortReels;
